import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'web-ui-components/lib/atoms/buttons';
import { Title } from 'web-ui-components/lib/atoms/text';
import { LoadingLocalTakeover } from 'web-ui-components/lib/organisms/takeovers';

import { ReasonsToGoPaperlessList } from './ReasonsToGoPaperlessList';
import PatternLibModalComponent from '../../common/modals/PatternLibModalComponent';

export const ModalBody = ({ content, hasAccountsLoaded }) => {
  return (
    <LoadingLocalTakeover show={hasAccountsLoaded}>
      <div className="web-ui-components c-paperless-preferences-splash">
        <ReasonsToGoPaperlessList content={content} />
        <Title size="h4">{content.paperlessInfoTitle}</Title>
        <p>{content.paperlessInfoBody1}</p>
        <p>{content.paperlessInfoBody2}</p>
      </div>
    </LoadingLocalTakeover>
  );
};

export const ModalFooter = ({
  onAcceptClick,
  onManageClick,
  isLoading,
  hasAccountsLoaded,
  content,
}) => (
  <div className="web-ui-components c-centered-group">
    <Button
      isLoading={isLoading}
      isDisabled={!hasAccountsLoaded}
      display="primary"
      tabIndex="0"
      onClick={onAcceptClick}
    >
      {content.preferencesAcceptClick}
    </Button>
    <Button disabled={isLoading} tabIndex="0" onClick={onManageClick}>
      {content.preferencesManageClick}
    </Button>
  </div>
);

export const PaperlessPreferencesSplashModal = ({
  show,
  onHide,
  onAcceptClick,
  onManageClick,
  isLoading,
  content,
  hasAccountsLoaded,
}) => (
  <PatternLibModalComponent
    show={show}
    onHide={onHide}
    bsSize={'medium'}
    modalBody={
      <ModalBody content={content} hasAccountsLoaded={hasAccountsLoaded} />
    }
    modalFooter={
      <ModalFooter
        content={content}
        onAcceptClick={onAcceptClick}
        onManageClick={onManageClick}
        isLoading={isLoading}
        hasAccountsLoaded={hasAccountsLoaded}
      />
    }
    customClass={'c-modal'}
    closeButton={false}
    backdrop="static"
  />
);

ModalFooter.propTypes = {
  onAcceptClick: PropTypes.func,
  onManageClick: PropTypes.func,
  isLoading: PropTypes.bool,
  hasAccountsLoaded: PropTypes.bool,
};

ModalBody.propTypes = {
  content: PropTypes.shape({
    paperlessInfoTitle: PropTypes.string,
    paperlessInfoBody1: PropTypes.string,
    paperlessInfoBody2: PropTypes.string,
    paperlessInfoBody3: PropTypes.string,
    paperlessInfoBody4: PropTypes.string,
  }),
  hasAccountsLoaded: PropTypes.bool,
};

PaperlessPreferencesSplashModal.propTypes = {
  show: PropTypes.bool,
  onHide: PropTypes.func,
  onAcceptClick: PropTypes.func,
  onManageClick: PropTypes.func,
  isLoading: PropTypes.bool,
  hasAccountsLoaded: PropTypes.bool,
  content: PropTypes.shape({
    paperlessInfoTitle: PropTypes.string,
    paperlessInfoBody1: PropTypes.string,
    paperlessInfoBody2: PropTypes.string,
    paperlessInfoBody3: PropTypes.string,
    paperlessInfoBody4: PropTypes.string,
  }),
};
